<script lang="ts" setup>
</script>

<template>
  <div class="mx-auto w-1200 pt-100">
    <div class="flex justify-between">
      <img src="@/home/assets/home/4/community.png" class="h-60 w-240 object-cover">
      <div class="flex gap-100 text-16 text-#171717 font-normal">
        <ul>
          <li class="text-20">关于我们</li>
          <li class="mt-50">
            <a href="https://docs.openatom.tech/" target="_blank">帮助文档</a>
          </li>
          <li class="mt-30">
            <a href="https://docs.openatom.tech/agreements/privacy/" target="_blank">隐私政策</a>
          </li>
          <li class="mt-30">
            <a href="https://docs.openatom.tech/agreements/terms-of-service/" target="_blank">使用条款</a>
          </li>
        </ul>
        <ul>
          <li class="text-20">联系我们</li>
          <li class="mt-50">地址：北京市北京经济技术开发区科谷一街8号际8号楼22层2201</li>
          <li class="mt-30">媒体合作：medla@openatom.org</li>
          <li class="mt-30">反馈建议：report@openatom.org</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="mt-100 bg-#f9fafb pb-10 pt-8 text-center text-16 text-#959ead">
    ©2025 开放原子开源基金会 版权所有 京ICP备2020036654号-4 京公网安备 11030102011541号
  </div>
</template>

<style lang="scss" scoped>
</style>
